// extracted by mini-css-extract-plugin
export default {"img":"img-LJg76X"};